import { FormControl } from '@angular/forms';

export class NoWhiteSpaceValidator {
    public StringIsNullOrWhiteSpace(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace' : true };
    }
}
